import React, { PropsWithChildren } from 'react';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import Hyperlink from '../../../components/atoms/Hyperlink/Hyperlink';

type RestrictionItem = {
  groupNames?: string[];
  pageLink: {
    name: string;
    url: string;
  };
};
type BadgeProps = PropsWithChildren<{
  restrictions: RestrictionItem[];
}>;

export function InheritedRestrictionsList({ restrictions }: BadgeProps) {
  const { t } = useSonTranslation('PageReadRestrictions');

  if (!restrictions || restrictions.length === 0) return null;

  const buildTree = (items: RestrictionItem[], index = 0) => {
    if (index >= items.length) return null;

    const current = items[index];
    const nextLevel = index + 1 < items.length ? buildTree(items, index + 1) : null;

    return (
      <li key={current.pageLink.url} className="page-read-restrictions__inherited-restrictions-list-item">
        <Hyperlink to={current.pageLink.url} className="page-read-restrictions__inherited-restrictions-link">
          {current.pageLink.name}
        </Hyperlink>
        {/* no list, if only one group item */}
        {current.groupNames && current.groupNames.length > 0
          ? (
              <>
                <p>
                  <dfn className="page-read-restrictions__dfn">{t('inheritedRestrictions.visibleBy')}: </dfn>
                  {current.groupNames.length === 1
                    ? (
                        <span className="page-read-restrictions__inherited-restrictions-group">
                          &nbsp;{current.groupNames[0]}
                        </span>
                      )
                    : null}
                </p>
                {current.groupNames.length > 1
                  ? (
                      <ul className="page-read-restrictions__inherited-restrictions-ul">
                        {current.groupNames.map((groupName, i) => (
                          <li key={i} className="page-read-restrictions__inherited-restrictions-li">
                            {groupName}
                          </li>
                        ))}
                      </ul>
                    )
                  : null}
              </>
            )
          : null }
        {nextLevel ? <ul className="page-read-restrictions__inherited-restrictions">{nextLevel}</ul> : null}
      </li>
    );
  };

  return <ul className="page-read-restrictions__inherited-restrictions">{buildTree(restrictions)}</ul>;
}
